import { getHttpMethods, respond } from "../Components/Utils/httpMethods";
import { enAPI } from "../../src/config";
import { formatRoles } from "../Components/Utils/PoolConfig";

export const getUserDetails = (username) => {
  return (dispatch, state) => {
    let store = state(),
      app = store.pool.userPool;
    dispatch({ type: "RESET_ERROR" });
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    const http = getHttpMethods(dispatch, state);
    http
      .get(`${enAPI}${app}/getuser/${username}`)
      .then((res) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        let Attributes = {};
        res.data.UserAttributes.forEach((attr) => {
          Attributes[attr.Name] = attr.Value;
        });
        dispatch({
          type: "SET_USER_DETAILS",
          data: { userDetails: { ...res.data, ...Attributes } },
        });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getUserDetails", err, dispatch);
        console.log("error:", err);
      });
  };
};

export const getUsers = (attribute_name, attribute_value, action) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    dispatch({ type: "RESET_PASSWORD", data: { success: undefined } });
    let input = {
      name: attribute_name,
      value: attribute_value,
      action,
    };
    http
      .post(`${enAPI}${userPool}/searchusers`, input)
      .then((res) => {
        let users = [];
        res.data &&
          res.data.Users.forEach((user) => {
            let Attributes = {};
            user.Attributes.forEach((attr) => {
              Attributes[attr.Name] = attr.Value;
            });
            users.push({
              ...user,
              ...Attributes,
            });
          });
        let lastKey = {
          lastEvaluatedKey: res.data.PaginationToken,
        };
        dispatch({
          type: "USERS_LIST",
          data: { usersList: users, lastKey: lastKey },
        });
        dispatch({
          type: "SET_SEARCH_ATTRIBUTE",
          data: {
            searchAttributes: { name: attribute_name, value: attribute_value },
          },
        });
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getUsersList", err, dispatch);
      });
  };
};

export const getRoles = () => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    http
      .get(`${enAPI}${userPool}/getroles`)
      .then((res) => {
        let finalRoles = formatRoles(userPool, res.data.Items);
        dispatch({ type: "SET_ROLES_LIST", data: { roles: finalRoles } });
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getRolesList", err, dispatch);
      });
  };
};

export const resetPassword = (data) => {
  return (dispatch, state) => {
    let store = state(),
      app = store.pool.userPool;
    dispatch({ type: "RESET_ERROR" });

    dispatch({ type: "SET_LOADING", data: { isLoading: true } });

    const http = getHttpMethods(dispatch, state);
    http
      .post(enAPI + `${app}/resetpassword`, data)
      .then((res) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        if (res.data) {
          dispatch({ type: "RESET_PASSWORD", data: { success: true } });
        }
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("resetpassword", err, dispatch);
        console.log("error:", err);
      });
  };
};

export const getCompanies = () => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    http
      .get(`${enAPI}${userPool}/companylist`)
      .then((res) => {
        let companies = [];
        res.data.forEach((company, index) => {
          companies.push({
            value: company,
            label: company,
          });
        });
        dispatch({ type: "SET_COMPANY_LIST", data: { companies: companies } });
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getCompaniesList", err, dispatch);
      });
  };
};

export const createUser = (poolObject) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    let api =
      poolObject.autoApproval || poolObject.internalUser
        ? "createuser"
        : "createusermanual";
    if (poolObject.internalUseronly) {
      api = "internal/createuser";
    }
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    http
      .get(
        `${enAPI}${userPool}/emailverify?email=${encodeURIComponent(
          poolObject["email"]
        )}`
      )
      .then((res) => {
        let email = res.data && res.data.email;
        if (!email) {
          http
            .post(`${enAPI}${userPool}/${api}`, poolObject)
            .then((res) => {
              dispatch({
                type: "SET_CREATE_USER",
                data: { usercreated: "User Created Successfully" },
              });
              dispatch({ type: "SET_LOADING", data: { isLoading: false } });
            })
            .catch((err) => {
              dispatch({ type: "SET_LOADING", data: { isLoading: false } });
              respond("createUser", err, dispatch);
            });
        } else {
          dispatch({ type: "SET_LOADING", data: { isLoading: false } });
          respond(
            "userExists",
            {
              message: "User with given email already exists",
            },
            dispatch
          );
        }
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("searchUsers", err, dispatch);
      });
  };
};

export const modifyUser = (poolObject) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    let api = poolObject.internalUseronly
      ? "internal/updateuser"
      : "modifyuser";

    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    http
      .post(`${enAPI}${userPool}/${api}`, poolObject)
      .then((res) => {
        dispatch({
          type: "SET_MODIFY_USER",
          data: { userModified: { ...res.data } },
        });
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("modifyUser", err, dispatch);
      });
  };
};

export const setSearchCriteria = (name, value) => {
  return (dispatch, state) => {
    dispatch({
      type: "SET_SEARCH_CRITERIA",
      data: { criteria: { attribute_name: name, attrbute_value: value } },
    });
  };
};
export const clearSearchCriteria = (name, value) => {
  return (dispatch, state) => {
    dispatch({
      type: "SET_SEARCH_CRITERIA",
      data: { criteria: undefined },
    });
  };
};

export const generateReport = (attribute_name, attribute_value) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    let loggedInUser = store.account.user.email;
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    let input = {
      name: attribute_name,
      value: attribute_value,
      loggedInUser,
    };
    http
      .post(`${enAPI}${userPool}/generatereport`, input)
      .then((res) => {
        setTimeout(() => {
          dispatch({ type: "SET_LOADING", data: { isLoading: false } });
          dispatch({
            type: "SET_GENERATE_REPORT",
            data: {
              report:
                "Request submitted successfully. Report would be generated and mailed to you.",
            },
          });
        }, 1000);
      })
      .catch((err) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        respond("getUsersList", err, dispatch);
      });
  };
};

export const listUserAuthEvents = (username) => {
  return (dispatch, state) => {
    const http = getHttpMethods(dispatch, state);
    const store = state();
    let userPool = store.pool.userPool;
    dispatch({ type: "SET_LOADING", data: { isLoading: true } });
    http
      .get(`${enAPI}${userPool}/getauthevents/${username}`)
      .then((res) => {
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
        dispatch({ type: "SET_AUTH_EVENTS", data: { events: res.data } });
      })
      .catch((err) => {
        console.log("Error:", err);
        dispatch({ type: "SET_LOADING", data: { isLoading: false } });
      });
  };
};

export const errorWhileFetch = (err) => {
  return (dispatch, state) => {
    dispatch({
      type: "SET_ERROR",
      data: { error_obj: { errorPath: err } },
    });
  };
};

export const setUserList = (list, lastKey) => {
  return (dispatch) => {
    dispatch({
      type: "USERS_LIST",
      data: { usersList: list, lastKey: lastKey },
    });
  };
};
